// extracted by mini-css-extract-plugin
module.exports = {"title":"confirmationDialog_title__1-XBP"};
    if(module.hot) {
      // 1783592039444
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  